<script setup lang="ts">
export interface DangerZoneAction {
	title: string;
	description?: string;
	label: string;
	loading?: boolean;
	onSelect: () => void;
}

defineProps<{
	actions: DangerZoneAction[];
}>();
</script>

<template>
	<div class="flex flex-col gap-8">
		<DFormSeparator :label="$t('common.danger_zone')" class="text-error" line="above" />

		<DCard :ui="{ root: 'ring-error' }">
			<div class="flex flex-col gap-6 text-sm">
				<div
					v-for="(action, index) in actions"
					:key="index"
					class="flex items-center justify-between gap-4"
				>
					<div>
						<p class="font-medium">
							{{ action.title }}
						</p>
						<p v-if="action.description" class="text-xs text-muted">
							{{ action.description }}
						</p>
					</div>
					<DButton
						variant="ghost"
						color="error"
						:label="action.label"
						:loading="action.loading"
						@click="action.onSelect()"
					/>
				</div>
			</div>
		</DCard>
	</div>
</template>
